import type { z } from 'zod';

import { contactPivotSchema } from './contact-pivot-schema';
import { contactLinkerWithPhoneNumberQuerySchema } from './contact-query-linker-with-phone-numbers-schema';

export const contactLinkerWithPhoneNumberPivotQuerySchema = contactLinkerWithPhoneNumberQuerySchema.extend({
  pivot: contactPivotSchema.optional(),
});

export type ContactLinkerWithPhoneNumberPivotQuerySchema = z.infer<typeof contactLinkerWithPhoneNumberPivotQuerySchema>;
